<script>
	import Footer from './components/footer.svelte';
	import Navbar from './components/navbar.svelte';
	import AboutSection from './components/screens/about-section.svelte';
	import InfoSection from './components/screens/info-section.svelte';
	import CertificationSection from './components/screens/certification-section.svelte';
	import RegisterSection from './components/screens/register-section.svelte';
	import DownloadsSection from './components/screens/downloads-section.svelte';
	import HomeSection from './components/screens/home-section.svelte';
	import FileSection from './components/screens/file-section.svelte';
	import NewsSection from './components/screens/news-section.svelte';
	import PostInfoSection from './components/screens/post-info-section.svelte';
	import InfoAlertSection from './components/screens/info-alert-section.svelte';
	import ContactFormSection from './components/screens/contact-form-section.svelte';
	import * as animateScroll from "svelte-scrollto";

	let y;

	let selectedPost;
	let selectedProyect;

	let getRoute = () => {
		return window.location.hash.split("/")[1] ? window.location.hash.split("/")[1] : "home";
	}

	let selected = getRoute();
	let subSelection = 0;


	let detailData;

	window.onhashchange = () => {
		selected = getRoute();
	}

	let height;

	let handleClickNav = (item, selectedItem) => {
		
		if(item == 'home') 	animateScroll.scrollToTop();
		
		subSelection = selectedItem;
		if(subSelection == 0)  animateScroll.scrollToTop();
		else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
		
		selected = item;

		window.location.hash = `#/${selected}`;
		
	}

	let handleClickRegisterProyect = (proyect) => {
		animateScroll.scrollToTop();
		selectedProyect = proyect;
		selected = "file";
		if (selectedProyect && selectedProyect.id) {
			window.location.hash = `#/${selected}/${selectedProyect.id}`;
		}else{
			window.location.hash = `#/${selected}`;
		}
	}

	let handleClickPost = (post) => {
		selectedPost = post;
		selected = 'post';
		if (selectedPost && selectedPost.id) {
			window.location.hash = `#/${selected}/${selectedPost.slug}`;
		}else{
			window.location.hash = `#/${selected}`;
		}
		
	}

	let handleInfoBoxClick = () => {
		selected = 'info-alert';
		window.location.hash = `#/${selected}`;
	}

	function handleClickContact(){
		selected = 'contact';
		window.location.hash = `#/${selected}`;
	}
	

</script>

<svelte:window bind:scrollY={y}/>

<main>
	<div class="container" style="min-width:100%" bind:clientHeight={height}>
			{#if selected == "home"}
				<div class="row" style="overflow: hidden;">
					<div class="col-12 padding-0 home-container" id="header">
						<img src="./img/background-paralax-intro.jpg" alt="" class="background-img" style="transform: translate(0,{y*3/5}px)">
						<div class="logo-aros-container">
							<img src="./img/aros-intro.svg" alt="" class="aros-img" style="transform: translate(0,{y*2.5/5}px); height: calc(120vh + {0.7*y}px);">
						</div>

						<div class="logo-text-container">
							<img src="./img/logo-CVS-intro.svg" alt="" class="logo-home clickable" on:click={handleClickNav('home')} style="transform: translate(0,{y*1.5/5}px)">
							<div class="home-text" style="transform: translate(0,{y*1/5}px)">
								<span class="suga-font">CERTIFICACIÓN DE</span>
								<span class="suga-font fix-margin">VIVIENDA SUSTENTABLE</span>
							</div>
						</div>
						<img src="./img/planta-paralax-intro1.png" alt="" class="leaf-img">
					</div>
				</div>
			{/if}

            <Navbar
				height={500}
				handleClickNav={handleClickNav}
				selected={selected}
				subSelection={subSelection}
			/>

			<div class="section-cvs padding-0">
				{#if selected == "home"}
					<HomeSection
							handleClickNav={handleClickNav}
							subSelection={subSelection}
					/>
				{/if}
				{#if selected == "about"}
					<AboutSection subSelection={subSelection}/>
				{/if}
				{#if selected == "info"}
					<InfoSection subSelection={subSelection} handleInfoBoxClick={handleInfoBoxClick}/>
				{/if}
				{#if selected == "certification"}
					<CertificationSection subSelection={subSelection}/>
				{/if}
				{#if selected == "register"}
					<RegisterSection handleClickRegisterProyect={handleClickRegisterProyect} subSelection={subSelection}/>
				{/if}
				{#if selected == "downloads"}
					<DownloadsSection subSelection={subSelection}/>
				{/if}
				{#if selected == "file"}
					<FileSection selectedProyect={selectedProyect}/>
				{/if}
				{#if selected == "news"}
					<NewsSection
							handleClickPost={handleClickPost}
							subSelection={subSelection}
					/>
				{/if}
				{#if selected == "post"}
					<PostInfoSection selectedPost={selectedPost} subSelection={subSelection}/>
				{/if}
				{#if selected == "info-alert"}
					<InfoAlertSection />
				{/if}
				{#if selected == "contact"}
					<ContactFormSection />
				{/if}
			</div>

			
			<button class="contact-btn" on:click|once={handleClickContact}>
				<span class="icon">
					<i class="far fa-envelope"></i>
				</span>
			</button> 

			<a class="linkedin-btn" href="https://www.linkedin.com/company/cvschile">
				<span class="icon">
					<i class="fab fa-linkedin-in"></i>
				</span>
			</a> 

			<a class="twitter-btn" href="https://twitter.com/CVSustentable">
				<span class="icon">
					<i class="fab fa-twitter"></i>
				</span>
			</a>

			<a class="instagram-btn" href="https://www.instagram.com/cvs_chile/">
				<span class="icon">
					<i class="fab fa-instagram"></i>
				</span>
			</a> 

			<Footer/>

        </div>
</main>

<style>

	.instagram-btn{
		width:60px;
		height:60px;
		border-radius:100%;
		right:0;
		bottom:0;
		position:fixed;
		margin-right:16px;
		margin-bottom:16px;
		border:none;
		outline:none;
		color:#FFF;
		font-size:36px;
		box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
		transition:.3s;  
		z-index: 10;
		text-align: center;
		padding-top: 3px;
		padding-left: 2px;
		background: #f09433; 
		background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); 
		background: -webkit-linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); 
		background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); 
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );
	}

	.instagram-btn:hover{
		background:white;
		color: #f09433;
	}

	.twitter-btn{
		width:60px;
		height:60px;
		border-radius:100%;
		background:#00ADE5;
		right:0;
		bottom:70px;
		position:fixed;
		margin-right:16px;
		margin-bottom:16px;
		border:none;
		outline:none;
		color:#FFF;
		font-size:36px;
		box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
		transition:.3s;  
		z-index: 10;
		text-align: center;
		padding-top: 3px;
	}

	.twitter-btn:hover{
		background:white;
		color: #00ADE5;
	}

	.linkedin-btn{
		width:60px;
		height:60px;
		border-radius:100%;
		background:#0274B3;
		right:0;
		bottom:140px;
		position:fixed;
		margin-right:16px;
		margin-bottom:16px;
		border:none;
		outline:none;
		color:#FFF;
		font-size:36px;
		box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
		transition:.3s;  
		z-index: 10;
		text-align: center;
		padding-top: 2px;
	}

	.linkedin-btn:hover{
		background:white;
		color: #0274B3;
	}

	.contact-btn{
		width:60px;
		height:60px;
		border-radius:100%;
		background:#F44336;
		right:0;
		bottom:210px;
		position:fixed;
		margin-right:16px;
		margin-bottom:16px;
		border:none;
		outline:none;
		color:#FFF;
		font-size:36px;
		box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
		transition:.3s;  
		z-index: 10;
		text-align: center;
		padding-top: 3px;
		padding-left: 12px;
	}

	.contact-btn:hover{
		background:white;
		color: #F44336;
	}

	.section-cvs{
		min-height: 100vh;
		background-color: white;
		padding-top: 100px;
	}

	.suga-font{
		font-family: 'suga-pro-extralight';
		font-size: 4.2vw !important;
		letter-spacing: 8px;
	}

	.fix-margin{
		margin-top: -4%;
	}

	.home-container{
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 11;
	}

	.logo-text-container{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: -20vh;
	}

	.logo-aros-container{
		position: absolute;
		max-width: 100vw;
	}

	.background-img{
		position: absolute;
		width: 100%;
		height: 100vh;
		left: 0;
		z-index: -1;
	}

	.aros-img{
		align-items: center;
		align-self: center;
		height: 120vh;
		left: 0;
		z-index: -1;
		max-width: 98vw;
	}
	.leaf-img{
		bottom: 0;
		position: absolute;
		width: 100%;
		left: 0;
	}

	.logo-home{
		width: 80%;
		max-width: 350px;
		max-height: 350px;
	}

	.home-text{
		color: white;
		width: 100%;
		text-align: center;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		font-size: 42px;
	}

	@media (max-width: 500px){
        .suga-font{
			font-size: 9.2vw !important;
    		letter-spacing: 3px;
		}
		.aros-img{
			max-width: 113vw;
		}
    }

	@media (max-height: 767px) and (min-width: 800px){
        .logo-home{
            width: 55%;
        }
		.suga-font{
			font-size: 4vw !important;
		}

    }

	@media (max-height: 680px) and (min-width: 800px){
        .logo-home{
            width: 45%;
        }
		.suga-font{
			font-size: 3.8vw !important;
		}
    }
	
</style>
